import React from 'react';
import { Banner, ButtonClean } from '@fourthwall/components';
export const CombinedAlert = ({ combinedName, combinedLink }) => {
    return (React.createElement(Banner, { appearance: "warning", title: React.createElement(React.Fragment, null,
            "This product is part of a combined listing:",
            ' ',
            React.createElement(ButtonClean, { to: combinedLink, label: combinedName }),
            ". It\u2019s not available on the shop as a separate product.") }));
};
